import { render, staticRenderFns } from "./ManagerDashboard2.vue?vue&type=template&id=134e9ad6&scoped=true&"
import script from "./ManagerDashboard2.vue?vue&type=script&lang=js&"
export * from "./ManagerDashboard2.vue?vue&type=script&lang=js&"
import style0 from "./ManagerDashboard2.vue?vue&type=style&index=0&id=134e9ad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134e9ad6",
  null
  
)

export default component.exports